/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService
 */

export const RoutingRuleDefinitionDiscriminantKey = '@type';
export const AiChatbotRoutingTypename = 'com.hubspot.cv.assignments.core.routing.AiChatbotRouting';
export const AiChatbotRoutingDiscriminant = 'AI_CHATBOT';
export const AiChatbotRoutingDiscriminantKey = '@type';
export const BotRoutingTypename = 'com.hubspot.cv.assignments.core.routing.BotRouting';
export const BotRoutingDiscriminant = 'BOT';
export const BotRoutingDiscriminantKey = '@type';
export const CustomerAgentComplexRoutingTypename = 'com.hubspot.cv.assignments.core.routing.CustomerAgentComplexRouting';
export const CustomerAgentComplexRoutingDiscriminant = 'CUSTOMER_AGENT_COMPLEX';
export const CustomerAgentComplexRoutingDiscriminantKey = '@type';
export const CustomerAgentRoutingTypename = 'com.hubspot.cv.assignments.core.routing.CustomerAgentRouting';
export const CustomerAgentRoutingDiscriminant = 'CUSTOMER_AGENT';
export const CustomerAgentRoutingDiscriminantKey = '@type';
export const InboxUsersRoutingTypename = 'com.hubspot.cv.assignments.core.routing.InboxUsersRouting';
export const InboxUsersRoutingDiscriminant = 'INBOX_USERS';
export const InboxUsersRoutingDiscriminantKey = '@type';
export const OwnerRoutingTypename = 'com.hubspot.cv.assignments.core.routing.OwnerRouting';
export const OwnerRoutingDiscriminant = 'OWNER';
export const OwnerRoutingDiscriminantKey = '@type';
export const QuoteOwnerRoutingTypename = 'com.hubspot.cv.assignments.core.routing.QuoteOwnerRouting';
export const QuoteOwnerRoutingDiscriminant = 'QUOTE_OWNER';
export const QuoteOwnerRoutingDiscriminantKey = '@type';
export const SkillBasedRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SkillBasedRouting';
export const SkillBasedRoutingDiscriminant = 'SKILL_BASED_ROUTING';
export const SkillBasedRoutingDiscriminantKey = '@type';
export const SkillRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SkillRouting';
export const SkillRoutingDiscriminant = 'SKILL';
export const SkillRoutingDiscriminantKey = '@type';
export const SpecifiedHoursRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SpecifiedHoursRouting';
export const SpecifiedHoursRoutingDiscriminant = 'SPECIFIED_HOURS';
export const SpecifiedHoursRoutingDiscriminantKey = '@type';
export const TeamsOnlyRoutingTypename = 'com.hubspot.cv.assignments.core.routing.TeamsOnlyRouting';
export const TeamsOnlyRoutingDiscriminant = 'TEAMS_ONLY';
export const TeamsOnlyRoutingDiscriminantKey = '@type';
export const UnassignedRoutingTypename = 'com.hubspot.cv.assignments.core.routing.UnassignedRouting';
export const UnassignedRoutingDiscriminant = 'UNASSIGNED';
export const UnassignedRoutingDiscriminantKey = '@type';
export const UsersAndTeamsRoutingTypename = 'com.hubspot.cv.assignments.core.routing.UsersAndTeamsRouting';
export const UsersAndTeamsRoutingDiscriminant = 'USERS_AND_TEAMS';
export const UsersAndTeamsRoutingDiscriminantKey = '@type';
export const WaitlistRoutingTypename = 'com.hubspot.cv.assignments.core.routing.WaitlistRouting';
export const WaitlistRoutingDiscriminant = 'WAITLIST';
export const WaitlistRoutingDiscriminantKey = '@type';
export const WorkflowRoutingTypename = 'com.hubspot.cv.assignments.core.routing.WorkflowRouting';
export const WorkflowRoutingDiscriminant = 'WORKFLOW_ROUTING';
export const WorkflowRoutingDiscriminantKey = '@type';
export const isMaintenanceModeEnabledRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'isMaintenanceModeEnabled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABWDoMUAiQ5eD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateNameRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'validateName',
  auth: 'app',
  fingerprint: 'xeFk9p-ZN86WSjOJghODtD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAgentRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'createAgent',
  auth: 'app',
  fingerprint: 'LD6UPinJXeSU3a3qyujVnD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentProfileRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'updateAgentProfile',
  auth: 'app',
  fingerprint: 'o3r26OOqF1A83H-Sc2l41T4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentProfileByUserIdRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentProfileByUserId',
  auth: 'app',
  fingerprint: 'ENQCoPd7p0M83H-Sc2l41T4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentByUserIdRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentByUserId',
  auth: 'app',
  fingerprint: 'ENQCoPd7p0Ph3M1jA5bpSD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentToneRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentTone',
  auth: 'app',
  fingerprint: 'ENQCoPd7p0P3JVqFpkFWqz4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiAgentOrThrowIfMultipleRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentOrThrowIfMultiple',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADmIF-fnkT5RT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiAgentsForPortalRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentsForPortal',
  auth: 'app',
  fingerprint: 'LP3IbM57wEhtBqZwu13etz4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiAgentProfilesForPortalRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentProfilesForPortal',
  auth: 'app',
  fingerprint: 'gH6-2YSBO0Qb1HPjwh1WID4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHydratedAiAgentDataForPortalRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getHydratedAiAgentDataForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAnk6TaiZPDGT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHydratedAiAgentDataForPortalV2Rpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getHydratedAiAgentDataForPortalV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAiJaQjxqxiBz4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteAgentRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'deleteAgent',
  auth: 'app',
  fingerprint: 'ZWFHm1kMw2mOQ99dyMYnND4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreAgentRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'restoreAgent',
  auth: 'app',
  fingerprint: 'YjE9mdW-BFqOQ99dyMYnND4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};